(ns net.kestec.mhda-pilgrimage.admin.setup
  (:require
    ["@mui/material/Paper" :default Paper]
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Button" :default Button]
    ["@mui/material/Card" :default Card]
    ["@mui/material/FormControlLabel" :default FormControlLabel]
    ["@mui/material/Switch" :default Switch]
    ["@mui/material/CardContent" :default CardContent]
    ["@mui/material/CardActions" :default CardActions]
    [day8.re-frame.http-fx]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.cms.editor :as editor]
    [net.kestec.mhda-pilgrimage.public.page-structure :refer [base-page]]
    [net.kestec.mhda-pilgrimage.admin.cms.cms-events :as-alias cms-events]
    [re-frame.core :as rf]
    [reagent.core :as r]

    ))




(defn main []
  [base-page
   [:> Paper {:sx {:padding "7px"}}
    [:br]
    [:> Typography {:variant "h2"} "Setup"]
    [:br]
    ;[:pre (pr-str @(rf/subscribe [::db/get ::cms-events/admin-globalNews]))]
    [:br]
    [:> Typography {:variant "h3"} "Globale News (vor der Anmeldung)"]
    (into [:<>]
          (for [news @(rf/subscribe [::db/get ::cms-events/admin-globalNews])]
            [:> Card

             [:> CardContent
              [:h5 (:title news)]

              [:div {:dangerouslySetInnerHTML (r/unsafe-html (str (:msg news)))}]

              ]
             [:> CardActions
              [:> Button {:variant "outlined"
                          :href    (str "/admin/news/" (:id news))} "Bearbeiten"]
              [:> FormControlLabel
               {:label "Veröffentlichen"
                :control (r/as-element [:> Switch {:variant "outlined" :checked (:published news)}])}]]

             ]))
    ]])

